import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {StackLegacy} from '../../layout/stack/stack-legacy';
import {Link} from '../../link/link';
import {Body} from '../../typography/body';

import type {ListItem} from '../types';

import styles from './list.module.css';

type Props = ListItem & {
    shouldTruncate?: boolean;
};

export function ListRow(props: Props) {
    return (
        // @ts-expect-error
        <Link as={RoutedLink} to={props.htmlUrlPath} preventUnderline={true} className={styles.row}>
            <StackLegacy spacing={2}>
                <Link
                    as='div'
                    href={props.htmlUrlPath}
                    variant='primary'
                    size='normal'
                    className={props.shouldTruncate ? styles.truncated : ''}
                >
                    {props.name}
                </Link>
                {props.subtitle && (
                    <Body size='small' color='light'>
                        {props.subtitle}
                    </Body>
                )}
            </StackLegacy>
            {props.formattedCount && props.countNoun && (
                <StackLegacy spacing={2}>
                    <Body isBold={true} size='normal'>
                        {props.formattedCount}
                    </Body>
                    <Body size='small' color='light'>
                        {props.countNoun}
                    </Body>
                </StackLegacy>
            )}
        </Link>
    );
}
